export default __webpack_public_path__ + "static/media/cp_geo_lu.f40a3315.svg";